import Vue from 'vue';

Vue.component('folder-list-vue', {
  data() {
    return {
      showFolderOpt: false,
    };
  },

  mounted() {
    // Get all the folder items
    const folderItems = document.querySelectorAll('.folder-list-container__item span:first-child');
    const listContainer = document.querySelector('.folder-list-container');
    const backLink = document.querySelector('.link__back'); //link to go back
    const folderList = document.querySelector('.folder-list-content-wrapper');

    folderList.classList.add('folder-list-hidden');

    // Add click event listener to the back link
    backLink.addEventListener('click', function() {
      folderList.classList.add('folder-list-hidden');
      listContainer.classList.remove('folder-list-hidden');
    });

    // Add click event listener to each folder item
    folderItems.forEach((folderItem) => {
      folderItem.addEventListener('click', function() {
        folderList.classList.remove('folder-list-hidden');
        listContainer.classList.add('folder-list-hidden');
      });
    });
  },

  methods: {
    showFolder(index) {
      const folderOptionsDiv = document.querySelector('.folder-options-div');
      const box = document.getElementsByClassName('folder-list-container__list')[0];
      const baseTop = window.innerWidth < 920 ? 249 : 165;
      const inc = 68;
      const newTop = baseTop + (index - 1) * inc;
      const folderListWrapper = document.querySelector('.folder-list-container');
      folderOptionsDiv.style.top = newTop - folderListWrapper.scrollTop + 'px';
      this.showFolderOpt = !this.showFolderOpt; // Toggle the showFolder state on each click
      folderOptionsDiv.style.right = 0;
      folderOptionsDiv.style.marginRight = '20px';
      folderOptionsDiv.style.left = 'unset';
      window.innerWidth > 920 && (folderOptionsDiv.style.left = box.offsetWidth + 'px');
      folderOptionsDiv.classList.toggle('change');
    },
    activeFolder() {
      const links = document.querySelectorAll('#folder-list li .link');
      links.forEach((link) => {
        link.addEventListener('click', () => {
          const currentlyActiveItem = document.querySelector('#folder-list li.folder-list-container__item--active');
          currentlyActiveItem.classList.remove('folder-list-container__item--active');
          link.closest('li').classList.add('folder-list-container__item--active');
        });
      });
    },
  },
});
